namespace $.$$ {

	/**
	 * @deprecated Legacy in-app registration form. Use `$shm_hitalama_entergate`.
	 */
	export class $shm_hitalama_profile_register extends $.$shm_hitalama_profile_register {

		@ $mol_action
		reset_key() {
			const auth = this.$.$mol_error_fence(
				()=> this.$.$giper_baza_auth.grab(),
				error => {
					if( error.message !== 'Too long key generation' ) {
						return this.$.$shm_hitalama_compat_crypto_error( error )
					}
					return this.$.$giper_baza_auth.grab()
				},
			)
			this.$.$giper_baza_auth.current( auth )
		}
		
		@ $mol_action
		submit( next?: any ) {
			$mol_wire_sync(this).reset_key()

			const profiles = this.profiles()
			if( !profiles ) return

			const profile = profiles.key( this.login(), 'auto' )?.remote( this.$.$shm_hitalama_profile.current() )

			profile?.Login(null)!.val( this.login() )
			profile?.version( $shm_hitalama_profile_migration.latest_version() )
			profile?.password( this.passwond() )
			if( this.$.$shm_hitalama_settings.selfhosted_tauri_enabled() ) profile?.selfhosted_defaults_ensure()

			if( profile ) {
				const home = $shm_hitalama_profile.home()
				home.Hitalama_profile(null)!.remote( profile )
				this.$.$shm_hitalama_app.selfhosted_tauri_logout( false )
				this.$.$mol_state_arg.value( 'section', null )
				// this.$.$mol_state_arg.value( 'section', 'profile' )
			}

		}

		@ $mol_mem
		account_exist() {
			return this.profiles()?.has( this.login() ) ?? false
		}

		@ $mol_mem
		submit_enabled() {
			if( this.login() == '' ) return false
			return this.message() ? false : true
		}

		@ $mol_mem
		message( next?: string ): string {
			return this.account_exist() 
				? this.account_exist_message().replace( '{login}', this.login() ) 
				: next ?? ''
		}
		
	}

}
